"use client";

import { useQuery } from "@tanstack/react-query";
import { getProductReviews } from "@/modules/products/actions/products";

export const useReviews = ({ productId }: { productId: string }) => {
  return useQuery({
    queryKey: ["reviews", productId],
    queryFn: async () => {
      const { reviews, average_rating, limit, offset, count } =
        await getProductReviews({
          productId,
          limit: 50, // Fetch more for now to calculate average client side if needed
        });
      return { reviews, average_rating, limit, offset, count };
    },
    enabled: !!productId,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: true,
  });
};
